import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511e3d56"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Help", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("ol", { id: "help" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I take a shot? "),
      /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"-30px"} }, [
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "Choose where to aim, press and hold the left mouse button."),
          /*#__PURE__*/_createElementVNode("li", null, "Pull the mouse away from the ball."),
          /*#__PURE__*/_createElementVNode("li", null, "Release the left mouse button. The further you pull the cue stick away from the cue the harder the shot is (this simulates the taking of a shot in real life).")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How can I further control or position the cue ball? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "Controlling the position of the cue ball is done by selecting the position of the red marker on the ball image below. The strength of the shot is shown on the strength meter below the ball position image."),
        /*#__PURE__*/_createElementVNode("img", { src: "images/help/position.png" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I join a game room? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "To join a room click on the game type. There is currently only one room per game therefore you will be entered into the game room automatically.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I go into a different game room? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "To leave the game room click menu button on the top right corner of the game screen then select the \"Exit Room\" item. Then do 3. (above) to join a new room. "),
        /*#__PURE__*/_createElementVNode("img", {
          src: "images/help/dropdown.png",
          style: {"width":"60%"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I invite a player to play a game? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "All of the players in the room are listed in the near the bottom left corner (shown in the image below). To invite a player to play click on the players name and the invitation menu will appear. Further instructions will be displayed on the screen."),
        /*#__PURE__*/_createElementVNode("img", {
          id: "players",
          src: "images/help/players.png"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I play a wager game against another player? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "Wager games are played using crypto currencies and the wager process is fully decentralized. Wager games can be played by both registered players and guests. You need to have a crypto wallet installed. We currently recommend MetaMask. The blockchains we currently support are Avalanche (AVAX), Fantom (FTM) and Binance Smart Chain (BNB) with more blockchains coming. If you wish to play a wager game against your opponent select a \"Wager\" game type from the game type selection list selection when you invite another player to play."),
        /*#__PURE__*/_createElementVNode("img", {
          src: "images/help/wager-game.png",
          style: {"width":"90%"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I set up my browser to play wager games? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Metamask is a browser crypto wallet extension pluggin. It is used to connect your browser to the blockchain. It can be downloaded from "),
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://metamask.io",
            target: "_blank"
          }, "metamask.io"),
          /*#__PURE__*/_createTextVNode(" or your browser pluggin store for all major browsers. You can find many guides on the internet on how to set up and install Metamask When you have installed Metamask you need to add the supported blockchain you want you use. We support Avalanche (AVAX), Fantom (FTM) and Binance Smart Chain (BNB) blockchains. Go to "),
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://chainlist.org",
            target: "_blank"
          }, "chainlist.org"),
          /*#__PURE__*/_createTextVNode(" to add the chain to Metamask then change the chain in Metamask. ")
        ]),
        /*#__PURE__*/_createElementVNode("img", {
          src: "images/help/metamask-fox.svg",
          alt: "Metamask Logo",
          style: {"width":"20%"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Which cryptocurrencies do you support for wagering? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "We currently support three crypto-currencies Binance Smart Chain (BNB), Fantom (FTM), and Avalanche (AVAX). All of these are EVM (Ethereum Virtual Machine) chains therefore they are all compatible with the Metamask browser wallet extension."),
        /*#__PURE__*/_createElementVNode("img", {
          src: "images/help/crypto-logos.png",
          alt: "Cryptocurrency Logos",
          style: {"width":"40%"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Where can I see and inspect the smart contract code for wagering? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "The EVM smart contract address is - 0x02a206e54Da793c38234A77c0EBeCe39490d812E."),
        /*#__PURE__*/_createElementVNode("p", null, "On the blockchain explorers the smart contracts can be found at the following locations:"),
        /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"-30px"} }, [
          /*#__PURE__*/_createElementVNode("ul", null, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Avalanche (AVAX)"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(),
              /*#__PURE__*/_createElementVNode("a", {
                href: "https://snowtrace.io/address/0x02a206e54da793c38234a77c0ebece39490d812e",
                target: "_blank"
              }, "https://snowtrace.io/address/0x02a206e54da793c38234a77c0ebece39490d812e")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Fantom (FTM)"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(),
              /*#__PURE__*/_createElementVNode("a", {
                href: "https://ftmscan.com/address/0x02a206e54da793c38234a77c0ebece39490d812e",
                target: "_blank"
              }, "https://ftmscan.com/address/0x02a206e54da793c38234a77c0ebece39490d812e")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Binance Smart Chain (BNB)"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(),
              /*#__PURE__*/_createElementVNode("a", {
                href: "https://bscscan.com/address/0x02a206e54Da793c38234A77c0EBeCe39490d812E",
                target: "_blank"
              }, "https://bscscan.com/address/0x02a206e54Da793c38234A77c0EBeCe39490d812E")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I buy cryptocurrencies? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, " You can buy crypto from an exchange. There are many exchanges to choose from depending on your location. Popular exchanges include Binance, Binance US, Coinbase, Kraken and Gemini. When you have brought your cryptocurrency you need to send it to your wallet. This process might differ slighty depending on the chain. If you are unsure please refer to a more depth guide. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I send a chat message? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "The chat are area is shown in the image below. It it a the bottom of the game. When you type your message on the single line at the bottom and click \"Send\" it is shown on the box above and is distributed to all of the other player is the game room. If you are playing a game the message is only sent to you opponent."),
        /*#__PURE__*/_createElementVNode("img", {
          src: "images/help/chat.png",
          style: {"width":"90%"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("How do I remove the orange dotted aiming line? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, "The right mouse button toggles the orange dotted aiming line. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" What are the rules for the pool and snooker games? "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createTextVNode("You can find the rules for all of the games at "),
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://www.booza.com/rules.html",
            target: "_blank"
          }, "https://www.booza.com/rules.html"),
          /*#__PURE__*/_createTextVNode(".")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "footer-buttons" }
const _hoisted_4 = { class: "clearfix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { onClose: _ctx.onOkay }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "confirmbtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOkay && _ctx.onOkay(...args)))
          }, "Okay")
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}